<template>
  <div>
    <div class="control">
    </div>
    <div>
      <div class="catalogue">
         <div class="catalogue3" id="catalogue1" @click="returnback">	&lt;返回</div>
         <div class="catalogue2" id="catalogue1" @click="contract">转账汇款</div>
      </div>
    </div>
      <div class="control3">
      <span class="font1">付款人信息</span>
      <div class="box">
          <span class="fontname">付款账号</span>
          <span class="fontval">6222020605016175552</span>
        <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
          <span class="fontname">可用余额：</span>
          <span class="fontval">￥ 50,000.00元</span>
        <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
          <span class="fontname">转账金额：</span>
          <span class="fontj">￥</span>
          <span class="mianfie">免手续费</span>
          <span class="fontj">伍万元整</span>
        <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
          <span class="fontred">您转账金额已超过当日期限</span>
      </div>
      <div class="control3">
        <span class="font1">收款人信息</span>
        <div class="box">
            <span class="fontname">收款人名称：</span>
            <span class="fontval">谢天</span>
            <span><img src="../images/flow/touxiang-2.png"></span>
          <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
            <span class="fontname">收款人账号：</span>
            <span class="fontval">6222020605016175552</span>
          <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
            <span class="fontname">收款银行：</span>
            <span class="fontval">招商银行股份有限公司</span>
          <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
            <span class="fontname">开户地：</span>
            <span class="fontval">台州市</span>
          <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
            <span class="fontname">收款支行：</span>
            <span class="fontval">三门支行</span>
          <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
            <span class="fontname">转账用途：</span>
            <span class="fontval">往来款</span>
          <div style="width: 273px; height: 1px; border: 1px solid #eeeeee" ></div>
        </div>
      </div>
      <div class="text1">
           <div class="bnt1" @click="signature">推送给客户</div> 
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // e-signature
  name: "flow",
  data() {
    return {
      judge: true,
      bank: "中国工商银行股份有限公司",
      name: "李晓伟",
    };
  },
  methods:{
      contract(){
        return;
         this.judge=true
         this.switchover()
         
      },
      prospectus (){
          this.judge=false
          this.switchover()
      },
      switchover (){
          let a = document.getElementById("catalogue1")    
          let b = document.getElementById("catalogue2")
          if(this.judge){
              b.style.fontWeight="500"
              a.style.fontWeight="bold"
          }else{
              a.style.fontWeight="500"
              b.style.fontWeight="bold"
          }
      },
      returnback(){
        this.$router.push({path:'/businessHandling'})
      },
      signature(){
        alert("已推送");
      }
  },


};
</script>

<style  scoped>
* {
  margin: 0;
}
.PaymentAccNo{
 height: 60upx;	
 display: flex;
 justify-content: space-between;
}
.fontname{
  width: 60px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 25px;
  letter-spacing: 0px;
}
.fontred{
  width: 120px;
  height: 14px;
  font-size: 10px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: right;
  color: #fb1f00;
  line-height: 25px;
  letter-spacing: 0px;
  text-align:right;
}
.mianfie{
  width: 48px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: right;
  color: #cccccc;
  line-height: 25px;
  letter-spacing: 0px;
}
.fontj{
  width: 14px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: right;
  color: #333333;
  line-height: 25px;
  letter-spacing: 0px;
}
.fontval{
  width: 131px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: right;
  color: #333333;
  line-height: 25px;
  letter-spacing: 0px;
  text-align-last: justify;
}
.bnt {
  width: 290px;
  height: 5rem;
  font-size: 2rem;
  /* font-weight: bold; */
}
.box{
  width: 274px;
  height: 132px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 4px;
}
.font1{
  width: 60px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 35px;
  letter-spacing: 0px;
}
.control {
  /* width: 290px; */
  height: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.control2 {
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.control4{
  font-size: 0.4rem;
  height: 150px;
  margin: 100 0 0 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content {
  width: 290px;
  height: 30rem;
  display: flex;
  /* justify-content: center; */
  overflow-y:auto;
  align-items: center;
  flex-direction: column;
}
.content1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.catalogue{
  width: 290px;
  height: 36px;
  background: #f3f3f3;
  border-radius: 5px 5px 0px 0px;
}
.catalogueback{
  width: 6px;
  height: 15px;
  background: #999999;
}
.catalogue1{
    width: 15%;
    /* margin-top: 3px; */
    height: 2rem;
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
}   
.catalogue2{
  width: 280px;
  height: 20px;
  margin-top: -25px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #09254c;
  line-height: 45px;
  letter-spacing: 0px;
  
}
.catalogue3{
    width: 50px;
    height: 20px;
    margin-top: -25px;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #09254c;
    line-height: 35px;
    letter-spacing: 0px;
} 
.text1{
   width: 290px;
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
   /* height: 10rem; */
   color: #333;
}

.bnt1{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    background: #3F96FC;
    width: 15rem;
    height: 3rem;
}
.fontcss1{
  width: 53px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #333333;
  line-height: 18px;
}
.fontcss{
  width: 53px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #1e88ff;
  line-height: 18px;
}
.control3{
  width: 50%;
  height: 20rem;
}
.fontcss2{
  margin-left: 55px;
  font-size: 13;
}
</style>